import { render, staticRenderFns } from "./extractManage.vue?vue&type=template&id=63904238&scoped=true&"
import script from "./extractManage.vue?vue&type=script&lang=js&"
export * from "./extractManage.vue?vue&type=script&lang=js&"
import style0 from "./extractManage.vue?vue&type=style&index=0&id=63904238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63904238",
  null
  
)

component.options.__file = "extractManage.vue"
export default component.exports